// extracted by mini-css-extract-plugin
export var container = "_ay-0";
export var icon = "_ay-1";
export var text = "_ay-2";